import api from './api';

const PAYMENT_ENDPOINT = '/payments';

export const subscribe = async (
	data: Payments.SubscribeData,
): Promise<Payments.SubscriptionResponse> => {
	const response = await api.post(`${PAYMENT_ENDPOINT}/subscribe`, data);
	return response.data;
};
